export function qrcode(_ctx) {
    return {
        styles: {
            main: { bg_opa: 255 },
        },
    };
}
